<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  methods: {
  },
};
</script>

<style lang="scss">
#app {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $grey-dark;
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 1920px;
  margin: 0 auto;
}
</style>
